export const deletetaskreq="deletetaskreq"
export const deletetasksucc="deletetasksucc"
export const deletetaskfail="deletetaskfail"